import React, { useState, useEffect } from 'react';
import { CommonPopup, SearchableIndexList } from '@/components';
import { showErrorToast } from '@/utils/toast';
import './index.scss';
import { JKCContact } from '@/jkc/utils/type';
import CreateJKCTaskApi from '@/fetch/business/jkc/createTask';
import { HttpStatusCode } from '@/fetch/core/constant';
import AddContactModal from '../AddContactModal';

interface IProps {
  visible: boolean;
  onClose: () => void;
  onSelect: (contact: JKCContact) => void;
}

const ContactListPopup: React.FC<IProps> = ({ visible, onClose, onSelect }) => {
  const [contacts, setContacts] = useState<any[]>([]);
  const [addContactVisible, setAddContactVisible] = useState(false);

  const fetchContacts = async () => {
    try {
      const res = await CreateJKCTaskApi.getContactList();
      if (res.code === HttpStatusCode.Success && Array.isArray(res.data)) {
        setContacts(res.data);
      } else {
        setContacts([]);
        showErrorToast(res?.message || '获取联系人列表失败');
      }
    } catch (error) {
      showErrorToast('获取联系人列表失败');
    }
  };

  useEffect(() => {
    if (visible) {
      fetchContacts();
    }
  }, [visible]);

  return (
    <CommonPopup
      className="contact-list-popup-jkc"
      visible={visible}
      title="选择联系人"
      bodyStyle={{ height: '80vh' }}
      position="bottom"
      hasClose={true}
      onClose={onClose}
    >
      <div className="contact-list">
        <SearchableIndexList
          data={contacts.map((v) => ({
            label: `${v.contactUserName} ${v.contactUserErp}`,
            id: `${v.contactUserId || v.contactUserPhone}-${v.contactUserErp || ''}`,
            value: `${v.contactUserId || v.contactUserPhone}`
          }))}
          onItemClick={(item) => {
            const selectedContact = contacts.find(
              (contact) =>
                String(contact.contactUserId || contact.contactUserPhone) ===
                String(item.value)
            );
            if (!selectedContact) {
              showErrorToast('联系人信息异常，请重试');
              return;
            }

            onSelect({
              userName: selectedContact.contactUserName,
              userPhone: selectedContact.contactUserPhone,
              contactUserId: selectedContact.contactUserId,
              thirdPartnerBelongCode: selectedContact.contactUserBelongCode,
              contactUserErp: selectedContact.contactUserErp
            });
          }}
          placeholder="搜索姓名/ERP"
        />
      </div>
      <div className="contact-list-popup-jkc__footer">
        <button onClick={() => setAddContactVisible(true)}>添加其他联系人</button>
      </div>
      {addContactVisible && (
        <AddContactModal
          visible={addContactVisible}
          onClose={() => setAddContactVisible(false)}
          onSuccess={() => {
            setAddContactVisible(false);
            fetchContacts();
          }}
        />
      )}
    </CommonPopup>
  );
};

export default ContactListPopup;
